export var PLAYER_API;
(function (PLAYER_API) {
    PLAYER_API["PLAY"] = "PLAY";
    PLAYER_API["PAUSE"] = "PAUSE";
    PLAYER_API["SET_PLAYER_MODE"] = "SET_PLAYER_MODE";
})(PLAYER_API || (PLAYER_API = {}));
//# sourceMappingURL=player-api.js.map